export function initSuccessMessages() {
    document.querySelectorAll('.success-message').forEach(x => {
        const closeButton = x.querySelector('.close-button');

        if (closeButton) {
            closeButton.addEventListener('click', () => {
                x.remove();
            });
        }
    });
}